export default __webpack_public_path__ + "static/7-yr-ciminal-check-img-7ce5eb8a995960611e11eada18617972.jpg";